import { AgentWidgetConfig } from "../../apis/agent.api";
import { cn } from "../../lib/utils";
import { X } from "lucide-react";
import { FC, HTMLAttributes } from "react";
import { Button } from "../../components/ui/button";
import AgentAvatar from "./agent-avatar";

interface iWidgetHeaderProps extends HTMLAttributes<HTMLElement> {
  onClose?: () => void;
  config?: AgentWidgetConfig;
}

const WidgetHeader: FC<iWidgetHeaderProps> = ({
  onClose,
  config,
  className,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn(
        "w-full flex justify-between items-center text-white rounded-[20px] p-4 py-3 bg-neutral-800",
        className
      )}
    >
      <div className="flex items-center gap-2">
        <AgentAvatar config={config} />
        <p className="font-medium text-nowrap">
          {config?.ai_agent.agent_name || "Outsella Agent"}{" "}
        </p>
      </div>

      <Button
        onClick={onClose}
        className="rounded-full bg-[rgba(255,255,255,0.14)] border-none size-[27px]"
        variant="outline"
        size="icon"
      >
        <X />
      </Button>
    </div>
  );
};

export default WidgetHeader;
